import { Button, Input } from "antd/lib";
import XStroke from "../../../public/icons/XStroke";
import React from "react";
import { useSearch } from "@/hooks/useSearch";
import { FilterTypes } from "@/constants/common";
import { useTranslation } from "react-i18next";

interface SearchProps {
  filterType: FilterTypes;
  placeholder?: string;
}

const Search: React.FC<SearchProps> = ({ filterType, placeholder }) => {
  const {
    searchValue,
    searchInputChangeHandler,
    searchHandler,
    resetInputSearchHandler,
    showSearchInputReset,
    searchUrlParam,
  } = useSearch(filterType);
  const { t } = useTranslation();

  return (
    <>
      <Input
        onPressEnter={searchHandler}
        value={searchValue}
        onChange={searchInputChangeHandler}
        placeholder={placeholder || t("common.filters.searchPlaceholder")}
        addonAfter={
          <Button
            type="text"
            className="search-btn"
            disabled={!searchValue.trim().length || searchValue === searchUrlParam}
            icon={<i className="icon-search_stroke" color={"#888888"} onClick={searchHandler} />}
          />
        }
        style={{ height: 36 }}
        allowClear
      />
      {showSearchInputReset && (
        <Button
          type="text"
          onClick={resetInputSearchHandler}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: "36px",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
          icon={<XStroke />}
        >
          {t("common.filters.searchResetBtn")}
        </Button>
      )}
    </>
  );
};

export default Search;
